import { useEffect, useState } from 'react';

const REVEAL_DELAY_MS = 500;
const MIN_SPINNER_MS = 400;

export const useDelayedReveal = (isOpen: boolean, isLoading: boolean) => {
  const [isRevealed, setIsRevealed] = useState(false);
  const [isHoldingSpinner, setIsHoldingSpinner] = useState(false);

  useEffect(() => {
    if (!isHoldingSpinner) return undefined;
    const timer = window.setTimeout(() => setIsHoldingSpinner(false), MIN_SPINNER_MS);
    return () => window.clearTimeout(timer);
  }, [isHoldingSpinner]);

  useEffect(() => {
    if (!isOpen) {
      setIsRevealed(false);
      return undefined;
    }
    if (isRevealed) return undefined;
    if (!isLoading) {
      setIsRevealed(true);
      return undefined;
    }
    const timer = window.setTimeout(() => {
      setIsRevealed(true);
      setIsHoldingSpinner(true);
    }, REVEAL_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [isLoading, isOpen, isRevealed]);

  return { isVisible: isOpen && isRevealed, isHoldingSpinner };
};
